export default {
  providerId: 'ov-okta',
  issuer: 'https://sso.renault.com/oauth2/aus133y6mks4ptDss417',
  clientId: 'irn-72947_ope_pkce_wiktrryyadvv',
  redirect_uri: '/okta',
  code_challenge: 'yOrdz3cRr_jinFqLyCbFcTbBM1nc7L-sD7gNpaW3vXU',
  code_verifier: 'wWkXTSGsnKAoTZfWzZzTsAzct1NSF4as9Pyz8A5aD3Q',
};
